import {Controller} from "@hotwired/stimulus";

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static outlets = [
        'search-filters-modal',
    ];

    static values = {
        label: {
            type: String,
            default: ''
        }
    }

    openModal(event) {
        event.preventDefault();

        const filterLabel = event.currentTarget.dataset.searchFiltersLinkLabelValue;

        dataLayer.push({
            "event": "dataLayer.gaEvent",
            "gaEvent": {
                "category": "Listing Search filters",
                "action": "extra_filters_popup_open",
                "label": filterLabel === 'top' ? '' : (filterLabel || ''),
            },
        });

        this.searchFiltersModalOutlet.open(event);
        setTimeout(() => {
            if (filterLabel === 'top') {
                const scrollContainer = document.querySelector(
                    '#search-filters-modal .overflow-section'
                );

                if (scrollContainer) {
                    scrollContainer.scrollTop = 0;
                }
                return;
            }

            if (filterLabel) {
                const targetElement = document.querySelector(
                    `[data-filter-section="${filterLabel}"]`
                );

                if (targetElement) {
                    targetElement.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }
            }
        }, 300);
    }
}
